import React from "react";

import ReusableTest from "../ReusableTest";

function Test() {
  return <ReusableTest path="listening_test/hcs" category="hcs"></ReusableTest>;
}

export default Test;
